export default __webpack_public_path__ + "static/waste-2b7bebefa76a02c7489fcc56cac5a10a.png";